import { Form } from '@mairistem/composants';
import dayjs from 'dayjs';

import { formatMonetaire } from '@/utils';

interface BonCCASProps {
  numero: string;
  dateValidite: string;
  montant: number;
}

const BonCCAS = (props: BonCCASProps) => {
  const { numero: numeroProps, dateValidite: dateProps, montant: montantProps } = props;

  return (
    <Form.Group style={{ margin: 0, flex: 1 }}>
      <Form.Field inline width={2}>
        <label>Bon CCAS</label>
      </Form.Field>
      <Form.Field inline width={2}>
        N°
        {' : '}
        <label>{numeroProps}</label>
      </Form.Field>
      <Form.Field inline width={3}>
        Date de validité
        {' : '}
        <label>{dayjs(dateProps).format('DD/MM/YYYY')}</label>
      </Form.Field>
      <Form.Field
        inline
        width={9}
        // @ts-expect-error
        style={{ textAlign: 'right' }}
      >
        Montant
        {' : '}
        <label>{formatMonetaire(montantProps, 2)}</label>
      </Form.Field>
    </Form.Group>
  );
};

export default BonCCAS;
